<template>
	<div class="wrapper">
		<EnvironmentInfo :env="env" />
		<div class="dashboard">
			<Sidebar v-if="isWeb" @handleWebSidebar="handleWebSidebar" />
			<MobileSidebar v-else :isOpen="openMobileSidebar" @handleSidebar="handleSidebar()" />
			<div :class="computedClass" id="dashboard__page">
				<Header v-if="isWeb" />
				<div :class="computedDashboardHolder" id="dashboard__holder">
					<MobileHeader @handleSidebar="handleSidebar()" v-if="!isWeb" />
					<router-view></router-view>
				</div>
				<Footer v-if="isWeb" />
			</div>
		</div>
	</div>
</template>

<script>
import Sidebar from '@/components/shared/Sidebar/Sidebar.vue';
import MobileSidebar from '@/components/shared/MobileSidebar/MobileSidebar.vue';
import Header from '@/components/shared/Header/Header.vue';
import MobileHeader from '@/components/shared/MobileHeader/MobileHeader.vue';
import Footer from '@/components/shared/Footer/Footer.vue';
import EnvironmentInfo from '@/components/shared/EnvironmentInfo/EnvironmentInfo.vue';

export default {
	name: 'Dashboard',
	components: { Sidebar, MobileSidebar, Header, MobileHeader, Footer, EnvironmentInfo },
	data: () => ({
		windowWidth: window.innerWidth,
		openMobileSidebar: false,
		openWebSidebar: true,
	}),
	mounted() {
		this.$nextTick(() => {
			window.addEventListener('resize', this.onResize);
		});
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.onResize);
	},
	methods: {
		onResize() {
			this.windowWidth = window.innerWidth;
		},
		handleSidebar() {
			this.openMobileSidebar = !this.openMobileSidebar;
		},
		handleWebSidebar() {
			this.openWebSidebar = !this.openWebSidebar;
		},
	},
	computed: {
		isWeb() {
			return this.windowWidth > 992;
		},
		isSafari() {
			return navigator.vendor == 'Apple Computer, Inc.';
		},
		env() {
			return process.env.VUE_APP_ENV;
		},
		computedClass() {
			return [
				'dashboard__page',
				'dashboard__page--env',
				this.openWebSidebar ? 'extra-padding' : '',
			];
		},
		computedDashboardHolder() {
			return [
				'dashboard__holder',
				'dashboard__holder--env',
				!this.isWeb && this.isSafari ? 'safari' : '',
			];
		},
	},
};
</script>
<style lang="scss">
@import 'Dashboard.scss';
</style>
